import BigNumber from 'bignumber.js';

export function percent(number) {
  // 小数点以下切り捨て
  return Math.floor(Number(number) * 100);
}

export const toNumber = num => {
  const number = new BigNumber(num);

  if (!number) console.warn(`Should be Number. Got wrong data. [${num}]`);
  return number;
};

/**
 * Round down
 * @param num {Number}
 * @param decimalPlaces {Number} 小数点の桁数 Default:2
 * @returns {number}
 */
export const roundDown = (num, decimalPlaces = 2) => {
  BigNumber.config({ ROUNDING_MODE: 1 });
  return new BigNumber(num).decimalPlaces(decimalPlaces).toNumber();
};

/**
 * Round down and format to String
 * @param num {Number}
 * @param decimalPlaces {Number} 小数点の桁数 Default:2
 * @returns {string}
 */
export const roundDownString = (num, decimalPlaces = 2) => {
  return new BigNumber(num).toFormat(decimalPlaces, BigNumber.ROUND_DOWN);
};

/**
 * Calculation percentage
 * @param compared {number}
 * @param base {number}
 * @returns {number}
 */
export const calcPercentage = (compared, base) => {
  if (base === 0) return 0;

  return new BigNumber(compared)
    .div(base)
    .times(100)
    .toNumber();
};

/**
 * Convert number. Decimal to percent.
 * （0.5 -> 50）
 * @param num
 * @return {number}
 */
export const decimalToPercent = num => {
  return new BigNumber(num).times(100).toNumber();
};

/**
 * Convert number. Percent to decimal.
 * （50 -> 0.5）
 * @param num
 * @return {number}
 */
export const percentToDecimal = num => {
  return new BigNumber(num).div(100).toNumber();
};

/**
 * Is finite
 * @param num
 * @return {boolean}
 */
export const isFinite = num => {
  return new BigNumber(num).isFinite();
};

/*
 * These function is OLD.
 * Need to make new function using bignumber.js instead of decimal.js
 */

// New function => decimalToPercent
import { Decimal } from 'decimal.js';

// New function => percentToDecimal
// パーセント表示を元に戻す（50 -> 0.5）
export function revert(num) {
  const dec = new Decimal(Number(num));
  return dec.div(100).toNumber();
}

export function convertNumberToAmountToMoney(val) {
  if (!val) return '0.00';
  const baseInt = Number(val);

  const intPart = baseInt > 0 ? Math.floor(baseInt) : Math.ceil(baseInt);

  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');

  let floatPart = '.00';

  const value2Array = val.toString().split('.');

  let result;

  if (value2Array.length === 2) {
    floatPart = value2Array[1].toString().slice(0, 2);

    if (floatPart.length === 1) {
      result = intPartFormat + '.' + floatPart + '0';
    } else {
      result = intPartFormat + '.' + floatPart;
    }
  } else {
    result = intPartFormat + floatPart;
  }

  if (baseInt > -1 && baseInt < 0) return `-${result}`;
  else return result;
}

export function numFloor(num) {
  return Math.floor(Number(num) * 100) / 100;
}

// Number かどうかのチェック
export function isNumber(value) {
  return typeof value === 'number' && isFinite(value);
}

import { currencySeparator, currencyPrecision } from '@/lib/currency';

export const formatNumber = (number, currency = 'usd', precision) => {
  const num = number;

  if (num === null || num === undefined) return '-';

  if (isNaN(num)) return '-';

  /*
   * Precision
   */
  const currentPrecision = precision ? precision : currencyPrecision(currency);

  // Format
  const fmt = {
    decimalSeparator: currencySeparator(currency).decimal,
    groupSeparator: currencySeparator(currency).group,
    groupSize: 3,
  };

  return new BigNumber(num).toFormat(currentPrecision, BigNumber.ROUND_DOWN, fmt);
};
